import axios from 'axios'
import config from '@/config'
import auth from '@/services/auth'
import store from '@/store'
import pako from 'pako'

const functionsUrl = config.midServer[process.env.APP_CONF.instance]

export default {
  async models_getDashboardModel({ commit }, cb) {
    const authToken = await auth.getIdToken()

    axios
      .get(`${functionsUrl}/dataGrid_read`, {
        params: { authToken, currentDash: store.state.currentDash },
      })
      .then(function(res) {
        var strData = pako.inflate(res.data.models.data, { to: 'string' })

        try {
          commit('models_setDashboardModel', JSON.parse(strData))
        } catch (err) {
          commit('models_setDashboardModel', {})
          console.error(err)
        }

        cb()
      })
  },
}
